import { useRecoilValue, useResetRecoilState } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import useOpenTask from "./useOpenTask";
import useIsRecordSeparatedPage from "./useIsRecordSeparatedPage";
import { userAtom } from "../recoil/userAtom";
import { MeditationGroupType } from "api/meditationRecordApi";
import { selectedMeditationRecordKeyAtom } from "recoil/selectedMeditationRecordAtom";

export default function useOpenMeditationRecord(
  meditationRecordKey?: string,
  groupType?: MeditationGroupType
) {
  const isRecordSeparatedPage = useIsRecordSeparatedPage();
  const user = useRecoilValue(userAtom);
  const patientState = useRecoilValue(patientAtom);
  const resetSelectedMeditationRecordKey = useResetRecoilState(
    selectedMeditationRecordKeyAtom
  );

  const taskId = "5-7-T";
  const taskKey = `${taskId}:${patientState?.patientId}`;

  const openTask = useOpenTask({
    taskKey: taskKey,
    meditationRecordKey: meditationRecordKey,
    params: groupType ? { groupType } : undefined,
  });
  const openMeditationRecordListPage = useOpenTask({
    taskKey: "meditation-records",
  });
  const openMeditationRecordDetailPage = useOpenTask({
    taskKey: "meditation-record-detail",
    meditationRecordKey: meditationRecordKey,
    params: groupType ? { groupType } : undefined,
  });

  function addToTabAndOpen() {
    // Reset any previously selected meditation record before opening, similar to useOpenThoughtRecord
    resetSelectedMeditationRecordKey();

    if (
      user?.accessToken &&
      isRecordSeparatedPage &&
      meditationRecordKey === undefined
    ) {
      openMeditationRecordListPage();
    } else if (
      user?.accessToken &&
      isRecordSeparatedPage &&
      meditationRecordKey
    ) {
      openMeditationRecordDetailPage();
    } else {
      openTask();
    }
  }

  return addToTabAndOpen;
}
